module.exports = __webpack_public_path__ + "static/media/view assigned subject.e3b46f20.svg";